

import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../css/GalleryVideos.css";

const videos = [
  { id: 1, title: "Company Overview", url: "dQw4w9WgXcQ", thumbnail: "https://skyhitmedia.in/media/Digital%20Marketing-skyhitmedia.jpg" },
  { id: 2, title: "Product Demo", url: "3JZ_D3ELwOQ", thumbnail: "https://skyhitmedia.in/media/Digital%20Marketing-skyhitmedia.jpg" },
  { id: 3, title: "Client Testimonials", url: "LXb3EKWsInQ", thumbnail: "https://skyhitmedia.in/media/Digital%20Marketing-skyhitmedia.jpg" },
  { id: 4, title: "Behind the Scenes", url: "YoWZOS4Qx9I", thumbnail: "https://skyhitmedia.in/media/Digital%20Marketing-skyhitmedia.jpg" },
];

const GalleryVideos = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  return (
    <section className="video-gallery">
      <h2 className="gallery-title">Our Video Collection</h2>
      <div className="video-list">
        {videos.map((video) => (
          <motion.div 
            key={video.id} 
            className="video-card" 
            onClick={() => setSelectedVideo(video.url)}
          >
            <div className="video-frame">
              <img src={video.thumbnail} alt={video.title} className="video-thumbnail" />
              <div className="play-overlay">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="50" viewBox="0 0 11 15">
                  <path id="Polygon_1337" d="M6.674,1.212a1,1,0,0,1,1.652,0l5.608,8.225A1,1,0,0,1,13.108,11H1.892a1,1,0,0,1-.826-1.563Z"
                        transform="translate(11) rotate(90)" fill="#FFFFFF"></path>
                </svg>
              </div>
            </div>
            <div className="video-title">{video.title}</div>
          </motion.div>
        ))}
      </div>

      {/* Video Popup */}
      <AnimatePresence>
        {selectedVideo && (
          <motion.div className="video-modal" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <motion.div className="modal-content" initial={{ y: 100 }} animate={{ y: 0 }} exit={{ y: 100 }}>
              <button className="close-button" onClick={() => setSelectedVideo(null)}>✕</button>
              <iframe 
                className="modal-iframe" 
                src={`https://www.youtube.com/embed/${selectedVideo}?autoplay=1`}
                title="Video Player" 
                frameBorder="0" 
                allow="autoplay; encrypted-media; picture-in-picture" 
                allowFullScreen
              ></iframe>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default GalleryVideos;
